import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'

function ConfirmationModal(props) {
    const { isConfimationModalOpen, setIsConfimationModalOpen, finalAction } = props
    return (
        <>
            <Modal show={isConfimationModalOpen} onHide={() => setIsConfimationModalOpen()} centered>
                <Modal.Body><b>Do you want to end current parking session ? </b></Modal.Body>
                <Modal.Footer className='confirationModalfooter'>
                    <Button variant="light" onClick={() => setIsConfimationModalOpen()}><b>No</b></Button>
                    <Button variant="light" onClick={finalAction}><b>Yes</b></Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

ConfirmationModal.propTypes = {
    dispatch: PropTypes.func,
    isConfimationModalOpen: PropTypes.bool,
    setIsConfimationModalOpen: PropTypes.func,
    finalAction: PropTypes.func
}

ConfirmationModal.defaulProps = {
    dispatch: noop,
    isConfimationModalOpen: false,
    setIsConfimationModalOpen: noop,
    finalAction: noop
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ConfirmationModal)